import { Card, pn } from "@compass/core";
import { DevExpressReport, renderReportColumn } from "components";
import { ExportGridData, ReportPropertyBase } from "generated/openApi";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export const ExportGrid = (props: {
  exportType: string | undefined;
  exportSubType: string | undefined;
  timezone: string | undefined;
  gridData: ExportGridData;
}) => {
  const appTenantName = useSelector((state: RootState) => state.app.tenantName);

  const onExporting = () => {
    let infoTuples: [string, string | undefined][] = [];

    props.gridData.filterDisplays?.forEach((filterDisplay) => {
      infoTuples.push([
        `${filterDisplay.label!}${filterDisplay.operator ? ` (${filterDisplay.operator})` : ""}`,
        filterDisplay.values?.join(", "),
      ]);
    });

    const currentTimestamp = new Date()
      .toLocaleString("sv-SE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        // hour: "2-digit",
        // minute: "2-digit",
        // second: "2-digit",
        // hour12: false,
      })
      .replace(/[^0-9]/g, "");

    return {
      header: `${props.exportType}${props.exportSubType ? ` ${props.exportSubType}` : ""}`,
      filename: `${appTenantName}_${props.exportType}${props.exportSubType ?? ""}_${currentTimestamp}`,
      tenantName: appTenantName,
      infoTuples: infoTuples,
    };
  };

  return (
    <Card header={`${props.exportType} ${props.exportSubType ? props.exportSubType : ""}`}>
      <DevExpressReport
        dataSource={props.gridData.rows}
        onExporting={onExporting}
        exportFormats={["excel", "csv", "pdf"]}
      >
        {props.gridData.columns?.map((property) =>
          renderReportColumn({
            property: property,
            propertyKey: pn<ReportPropertyBase>("fullIdentifier"),
            timezone: props.timezone,
          })
        )}
      </DevExpressReport>
    </Card>
  );
};
